export default {
  quizzes: [],
  quiz: {},
  number: '',
  cardNumber: '',
  suit: null,
  url: '',
  name: '',
  description: '',
  hint: '',
  lat: 0.0,
  lng: 0.0,
  radius: 0
}
